import {z} from "zod"

export const CircularRefNodeDefinition = {
    validation: {
        parameters: z.object({
            refId: z.number(),
        }),
    },
}
